import { Controller } from "@hotwired/stimulus"

// FAQ accordion. State lives as data-open on the item; CSS shows the answer and
// rotates the plus. One open at a time.
//
// Markup:
//   <div data-controller="marketing-faq">
//     <div class="mk-faq-i" data-open="false" data-marketing-faq-target="item">
//       <button class="mk-faq-q" aria-expanded="false"
//               data-action="click->marketing-faq#toggle">Question<i>+</i></button>
//       <div class="mk-faq-a">Answer</div>
//     </div>
//
// The question button must carry .mk-faq-q: answers may contain their own links
// or buttons, so the toggle is found by class rather than "first button in item".
export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    const item = event.currentTarget.closest("[data-marketing-faq-target='item']")
    if (!item) return

    const opening = item.dataset.open !== "true"

    this.itemTargets.forEach((el) => {
      const open = el === item && opening
      el.dataset.open = String(open)
      el.querySelector(".mk-faq-q")?.setAttribute("aria-expanded", String(open))
    })
  }
}
